var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpringHeaderDecoration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_29423_6731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 6C40.2581 6 43.7615 9.22601 44.2021 13.3672C45.5061 12.5038 47.069 12 48.75 12C53.3064 12 57 15.6937 57 20.25C57 21.9309 56.4951 23.4929 55.6318 24.7969C59.7735 25.237 63 28.7416 63 33C63 37.2584 59.7735 40.762 55.6318 41.2021C56.4954 42.5062 57 44.0688 57 45.75C57 50.3064 53.3064 54 48.75 54C47.0688 54 45.5062 53.4954 44.2021 52.6318C43.762 56.7735 40.2584 60 36 60C31.7416 60 28.237 56.7735 27.7969 52.6318C26.4929 53.4951 24.9309 54 23.25 54C18.6937 54 15 50.3064 15 45.75C15 44.069 15.5038 42.5061 16.3672 41.2021C12.226 40.7615 9 37.2581 9 33C9 28.7419 12.226 25.2374 16.3672 24.7969C15.5041 23.493 15 21.9307 15 20.25C15 15.6937 18.6937 12 23.25 12C24.9307 12 26.493 12.5041 27.7969 13.3672C28.2374 9.22596 31.7419 6 36 6ZM31.4521 21.1318C31.0428 24.9837 27.9837 28.0428 24.1318 28.4521C24.9954 29.7562 25.5 31.3188 25.5 33C25.5 34.6809 24.9951 36.2429 24.1318 37.5469C27.9834 37.9562 31.0424 41.0157 31.4521 44.8672C32.7561 44.0038 34.319 43.5 36 43.5C37.6807 43.5 39.243 44.0041 40.5469 44.8672C40.9566 41.016 44.016 37.9566 47.8672 37.5469C47.0041 36.243 46.5 34.6807 46.5 33C46.5 31.319 47.0038 29.7561 47.8672 28.4521C44.0157 28.0424 40.9562 24.9834 40.5469 21.1318C39.2429 21.9951 37.6809 22.5 36 22.5C34.3188 22.5 32.7562 21.9954 31.4521 21.1318Z",
    fill: "#EA8998"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_29423_6731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 14.25C38.9564 14.25 41.3895 16.4893 41.6963 19.3643C42.6017 18.7651 43.6875 18.416 44.8545 18.416C48.0184 18.4163 50.583 20.9815 50.583 24.1455C50.5829 25.313 50.2326 26.3981 49.6328 27.3037C52.5091 27.6092 54.75 30.0436 54.75 33.001C54.7498 35.9581 52.5089 38.3907 49.6328 38.6963C50.2325 39.6019 50.583 40.687 50.583 41.8545C50.5828 45.0184 48.0184 47.5828 44.8545 47.583C43.687 47.583 42.6019 47.2325 41.6963 46.6328C41.3914 49.5098 38.9578 51.751 36 51.751C33.0422 51.7509 30.6086 49.5097 30.3037 46.6328C29.3982 47.2323 28.3137 47.5829 27.1465 47.583C23.9825 47.583 21.4172 45.0185 21.417 41.8545C21.417 40.6873 21.7668 39.6018 22.3662 38.6963C19.4905 38.3904 17.2502 35.9579 17.25 33.001C17.25 30.0439 19.4903 27.6096 22.3662 27.3037C21.7667 26.3982 21.4171 25.3128 21.417 24.1455C21.417 20.9814 23.9824 18.416 27.1465 18.416C28.3135 18.4161 29.3984 18.766 30.3037 19.3652C30.61 16.4899 33.0434 14.2501 36 14.25ZM32.8418 24.7578C32.5573 27.4331 30.4324 29.5573 27.7568 29.8408C28.3572 30.7468 28.708 31.8327 28.708 33.001C28.7079 34.1677 28.3578 35.252 27.7588 36.1572C30.4338 36.4416 32.5577 38.5671 32.8418 41.2422C33.7473 40.6427 34.8327 40.293 36 40.293C37.167 40.293 38.2519 40.643 39.1572 41.2422C39.4412 38.5678 41.5653 36.4425 44.2393 36.1572C43.6405 35.2521 43.2921 34.1674 43.292 33.001C43.292 31.8331 43.6412 30.7466 44.2412 29.8408C41.5666 29.5563 39.4416 27.4325 39.1572 24.7578C38.2517 25.3572 37.1672 25.708 36 25.708C34.8324 25.708 33.7474 25.3576 32.8418 24.7578Z",
    fill: "#F4D5AD"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_29423_6731)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 33,
    r: 9,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_29423_6731",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_29423_6731"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_29423_6731",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_29423_6731",
    x: 8.25,
    y: 8.25,
    width: 55.5,
    height: 55.501,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_29423_6731"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_29423_6731",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_29423_6731",
    x: 18,
    y: 18,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_29423_6731"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_29423_6731",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpringHeaderDecoration);
export default __webpack_public_path__ + "static/media/springHeaderDecoration.10ea945b62ed3f267057f04bb978f2cf.svg";
export { ForwardRef as ReactComponent };